<template>
  <div id="invitation">

    <div>

    </div>
    <div>
      <div style="color: #fff; padding: 65px; text-align: center; line-height: 30px; font-weight: bolder">
        本页面将在2023年
        <span style="text-decoration:underline">6月30日18:00</span>
        <br/>
        停止运维， 请前往新页面下载
      </div>

      <div style="color: #fff; padding: 10px 65px; text-align: center;font-size: 12px">点击下方按钮跳转到新页面</div>
      <sugr-button :sugrType="'newPage'" @click="goNewPage()">新码入组</sugr-button>
    </div>
  </div>
</template>
<script>
import SugrButton from "../../components/SugrButton";
export default {
  name: "invitation-page",
  components: {
    SugrButton
  },
  data() {
    return {
      urlStr: ''
    }
  },
  created() {
    this.urlStr = decodeURIComponent(window.location.href).split("?")[1] || '';
  },
  mounted() {

  },
  methods: {
    goNewPage() {
      window.location.href = 'https://intervene.sugrq.com/h5register/#/?' + this.urlStr
    }
  }
};
</script>
<style lang="scss" scoped>
#invitation {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  //background: #00aaff;
  /* 加载背景图 */
  background-image: url('../../assets/invitation/newPage.png');
  /* 背景图垂直、水平均居中 */
  background-position: center center;
  /* 背景图不平铺 */
  background-repeat: no-repeat;
  /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
  background-attachment: fixed;
  /* 让背景图基于容器大小伸缩 */
  background-size: cover;
  /* 设置背景颜色，背景图加载过程中会显示背景色 */
  background-color: #464646;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>